<template>
    <div>
        <footer class="main-footer div-home">
            <div id="back-to-top" data-spy="affix" data-offset-top="10" class="back-to-top affix" style="display: block;">
                <button class="btn btn-primary" title="Back to Top">
                    <i class="fa fa-angle-up"></i>
                </button>
            </div>
            <div class="container" style="overflow:hidden">
                <footer-info></footer-info>
            </div>
            <footer-description></footer-description>
            <footer-copyright></footer-copyright>

        </footer>
   </div>
</template>

<script>
    import footerCopyright from './footerCopyright.vue'
    import footerDescription from './footerDescription.vue'
    import footerInfo from './footerInfo.vue'
 
    export default {
        data() {
            return {
                isUserLogined: false
            }
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        components: {
            'footer-copyright': footerCopyright,
            'footer-description': footerDescription,
            'footer-info': footerInfo,
             
        }
    }
</script>

<style scoped>
 
     

     
</style>